import React, { useEffect, useState } from "react";
import UserTable from "../modules/user/components/UserTable";
import { Typography, Box, TablePagination } from "@mui/material";
import Button from "../ui/elements/buttons/Button";
import { useUsers } from "../modules/user/queries/useUsers"
import { User } from "../modules/user/userType/User";
import { Exhibitor } from "../modules/exhibitor/exhibitorType/Exhibitor";
import MapUserPopup from "../modules/user/components/MapUserPopup";
import ControlPanel from "../utils/ControlPanel";
import { SortField } from "../utils/schema/SortType";
import { useExhibitors } from "../modules/exhibitor/queries/useExhibitors";
import CircularLoader from "../ui/elements/loader/CircularLoader";
import { ExhibitorFilter } from "../utils/schema/ExhibitorFilter";
import { useInfiniteExhibitors } from "../modules/exhibitor/queries/useInfiniteExhibitors";

const Users: React.FC = () => {

  const [sortFields, setSortFields] = useState<SortField[]>([{ field: "username", order: "asc" }]);
  const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 15 });
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [searchText, setSearchText] = useState("");
  const [popupUserSearchText, setPopupUserSearchText] = useState("");
  const [popupExhibitorSearchText, setPopupExhibitorSearchText] = useState("");
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const effectiveUserSearchText = openPopup ? popupUserSearchText : searchText;
  const [filters, setFilters] = useState<ExhibitorFilter>();
 const trimmedSearchText = searchText.trim();
const { usersData, usersCount , refetch:refetchUsers, isLoading :userLoading} = useUsers({
  sortFields,
  ...pagination,
  filters,
  searchText: trimmedSearchText === "" ? undefined : trimmedSearchText,
});
  console.log("searchText", searchText);



  const users: User[] = usersData?.data?.data || []; 
  const totalPageCount = usersCount.data;

  const PAGE_SIZE = 100;

  const {
    data: exhibitorsData,
    fetchNextPage: fetchExhibitorsNextPage,
    hasNextPage: hasExhibitorsNextPage,
    isFetchingNextPage: isFetchingExhibitorsNextPage,
    isLoading: isLoading,
    refetch: refetchExhibitors,
  } = useInfiniteExhibitors({ rowsPerPage: PAGE_SIZE, searchExhibitor: popupExhibitorSearchText });

  
  const exhibitors = exhibitorsData?.pages.flatMap((page) => page.data) || [];
  const totalExhibitors = exhibitorsData?.pages?.[0]?.pagination?.total || 0;


   useEffect(() => {
      // Keep fetching until we've loaded all items
      if (
        totalExhibitors > 0 &&
        exhibitors.length < totalExhibitors &&
        hasExhibitorsNextPage &&
        !isFetchingExhibitorsNextPage
      ) {
        fetchExhibitorsNextPage();
      }
    }, [
      exhibitors.length,
      totalExhibitors,
      hasExhibitorsNextPage,
      isFetchingExhibitorsNextPage,
      fetchExhibitorsNextPage,
    ]);

  const handleOpenPopup = () => {
    setOpenPopup(true);
    setIsEdit(false);
    setSearchText("");
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPagination(prev => ({ ...prev, page: newPage + 1 }));
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPagination({ page: 1, rowsPerPage: parseInt(event.target.value, 10) });
  };

   useEffect(() => {
      setPagination(prev => ({ ...prev, page: 1 }));
    }, [searchText, filters]);


  return (
    <Box>
      <Box
  display="flex"
  flexDirection={{ xs: "column", sm: "row" }}
  justifyContent="space-between"
  alignItems={{ xs: "flex-start", sm: "center" }}
  padding="20px"
  paddingTop="40px"
  gap="20px"
  paddingBottom={0}
>
  {/* Left side: User Mapping + Map Button */}
  <Box
    display="flex"
    flexDirection="row"
    alignItems="center"
    gap="10px"
    flexWrap="wrap"
  >
    <Typography
      fontSize={{ xs: "24px", sm: "34px" }}
      fontWeight={500}
    >
      User Mapping
    </Typography>

    <Button
      onClick={handleOpenPopup}
      sx={{
        backgroundColor: "#F6333F",
        color: "white",
        whiteSpace: "nowrap",
      }}
    >
      Map User
    </Button>
  </Box>

  {/* Right side: Control Panel */}
  <Box width={{ xs: "100%", sm: "auto" }}>
    <ControlPanel
      pageType="users"
      setSearchText={setSearchText}
      searchText={searchText}
      exhibitors={exhibitors}
      filters={filters}
      setFilters={setFilters}
    />
  </Box>
</Box>

      {isLoading ? <CircularLoader/> :
      <Box>
        <TablePagination
          component="div"
          count={totalPageCount || 0}
          page={pagination.page-1}
          onPageChange={handleChangePage}
          rowsPerPage={pagination.rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 15, 20, 25]}
        />
        <UserTable 
          users={users} 
          open={openPopup} 
          setOpen={setOpenPopup} 
          refetchUsers={refetchUsers} 
          selectedUsers={selectedUsers} 
          setSelectedUsers={setSelectedUsers}
          setIsEdit={setIsEdit}
          userLoading={userLoading}
        />
      </Box>
      }
      <MapUserPopup 
        open={openPopup} 
        onClose={handleClosePopup} 
        users={users} 
        exhibitors={exhibitors}  
        userSearchText={popupUserSearchText} 
        setUserSearchText={setPopupUserSearchText} 
        exhibitorSearchText={popupExhibitorSearchText} 
        setExhibitorSearchText={setPopupExhibitorSearchText} 
        selectedUsers={selectedUsers} 
        setSelectedUsers={setSelectedUsers} 
        refetchUsers={refetchUsers}
        isEdit={isEdit}
        fetchExhibitorsNextPage={fetchExhibitorsNextPage}
        hasExhibitorsNextPage={hasExhibitorsNextPage}
        isFetchingExhibitorsNextPage={isFetchingExhibitorsNextPage}
        refetchExhibitors={refetchExhibitors}

      />
    </Box>
  );
};

export default Users;
